/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Sidebar_Usage_UsedInputs */



/**
* | output |
* | --- |
* | "{pct}% of today's allowance used" |
*
* @param {Sidebar_Usage_UsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_usage_used = /** @type {((inputs: Sidebar_Usage_UsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Usage_UsedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.pct}% des heutigen Guthabens verbraucht`)
	return /** @type {LocalizedString} */ (`${i?.pct}% of today's allowance used`)
});